/**
 * Created by mac on 5/2/20
 */

const ActionPlayer = function (options) { 
    options = options || {};
    this.options = options;

    if (Array.isArray(options)) {
        options = { actions: options };
    } else if (typeof options === "function") {
        options = { actions: [options] };
    }

    this.actions = [];
    this.add(options.actions || []);
};

ActionPlayer.prototype.add = function (actions) {
    if (Array.isArray(actions)) {
        actions.forEach((action) => {
            this.add(action);
        });
    } else if (actions) {
        this.actions.push(actions);
    }
};

ActionPlayer.prototype._playNext = function () {
    if (this.actionTimeout) {
        cleverapps.timeouts.clearTimeout(this.actionTimeout);
        this.actionTimeout = undefined;
    }

    if (this._stopped) {
        return;
    }

    if (this.index === this.actions.length) {
        this._stopped = true;

        if (this.onCompleteListener) {
            this.onCompleteListener.call(null);
        }

        if (this.onSuccessListener) {
            this.onSuccessListener.call(null);
        }

        return;
    }

    let active = true;

    const resolve = function (...args) {
        if (active) {
            active = false;
            this._playNext.call(this, ...args);
        }
    }.bind(this);

    const reject = function (...args) {
        if (active) {
            active = false;
            this.stop.call(this, ...args);
        }
    }.bind(this);

    if (this.options.actionTimeout) {
        this.actionTimeout = cleverapps.timeouts.setTimeout(reject, this.options.actionTimeout);
    }

    this.actions[this.index++](resolve, reject);
};

ActionPlayer.prototype.onSuccess = function (callback) {
    this.onSuccessListener = callback;
};

ActionPlayer.prototype.onFailure = function (callback) {
    this.onFailureListener = callback;
};

ActionPlayer.prototype.onComplete = function (callback) {
    this.onCompleteListener = callback;
};

ActionPlayer.prototype.play = function (callback) {
    this.index = 0;
    if (callback) {
        this.onSuccess(callback);
    }
    this._playNext();
};

ActionPlayer.prototype.stop = function (...args) {
    if (!this._stopped) {
        this._stopped = true;

        if (this.onCompleteListener) {
            this.onCompleteListener.call(null);
        }

        if (this.onFailureListener) {
            this.onFailureListener.call(null, ...args);
        }
    }
};

ActionPlayer.prototype.isStopped = function () {
    return this._stopped;
};

ActionPlayer.prototype.isRunning = function () {
    return !this.isStopped();
};

ActionPlayer.parallel = function (actions) {
    return function (resolve, reject) {
        actions = [actions].flat();

        const waiter = cleverapps.wait(actions.length, resolve);

        actions.forEach((action) => {
            action(cleverapps.once(waiter), reject);
        });
    };
};

ActionPlayer.serial = function (actions) {
    return function (resolve, reject) {
        const player = new ActionPlayer({ actions });
        player.onSuccess(resolve);
        player.onFailure(reject);
        player.play();
    };
};